<template>
<div class="min-w-sm max-w-sm lg:min-w-xl lg:max-w-xl mx-5 h-64 text-white flex flex-col text-left">
  <typical
    class="mb-0 pb-0 text-yellow-300 leading-snug"
    :steps="[$t('The following activities you are about to experience'), 1500]"
    :wrapper="'h1'"
  ></typical>
  <typical
    v-show="delayShow"
    class="typing-blinker mt-0 pt-0 italic text-3xl leading-snug"
    :steps="['', 4000, $t('are NOT your standard questions'), 1000, $t('are scoring multiple psychological models'), 1000]"
    :loop="Infinity"
    :wrapper="'h1'"
  ></typical>
</div>
</template>

<script>
import typical from 'vue-typical'
  export default {
    props: {
      route:'',
    },
    components: {
      typical,
    },
    data(){
      return{
        delayShow:false,
      }
    },
    created(){
      setTimeout(()=>{
        this.delayShow=true;
      },4000)
    }
  };
</script>
<style>
  .typing-blinker::after {
    content: "|";
    opacity: 1;
    animation: blink 600ms steps(30, end) infinite;
  }
  @keyframes blink {
    to {
      opacity: 0;
    }
  }
</style>